import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { AlertVariants } from "./constants";
import { Body, Label, Link } from "../../Atoms";
import { Icon, IconButton } from "../../Molecules";
import { IconButtonVariants, IconButtonWeights, } from "../../Molecules/Button/Icon/constants";
import { StyledAlertContainer, StyledCloseIconContainer, StyledIconContainer, StyledTextContainer, } from "./Alert.style";
import { IconVariants } from "../../Molecules/Images/Icon/constants";
import { LabelVariants } from "../../Atoms/Text/Label/constants";
import { useState } from "react";
const Alert = ({ body = "Text Body. Lorem ipsum dolor sit amet nam harum link.", title = "label", hasIcon = true, variant = AlertVariants.neutral, linkUrl = "", linkText = "", onClose = () => { }, }) => {
    const [visible, setVisible] = useState(true);
    const getIconVariant = () => {
        switch (variant) {
            case AlertVariants.neutral:
                return IconVariants.neutral;
            case AlertVariants.success:
                return IconVariants.positive;
            case AlertVariants.error:
                return IconVariants.negative;
        }
    };
    const handleIconType = (variant) => {
        if (hasIcon) {
            switch (variant) {
                case AlertVariants.neutral:
                    return "itaufonts_informacao";
                case AlertVariants.success:
                    return "itaufonts_check";
                case AlertVariants.error:
                    return "itaufonts_fechar";
            }
        }
        return "";
    };
    const handleCloseAlert = () => {
        setVisible(false);
        onClose();
    };
    return (_jsx(_Fragment, { children: visible && (_jsxs(StyledAlertContainer, { variant: variant, children: [_jsx(StyledIconContainer, { children: _jsx(Icon, { name: handleIconType(variant), variant: getIconVariant(), size: "large" }) }), _jsxs(StyledTextContainer, { children: [_jsx(Label, { variant: LabelVariants.neutral, children: title }), _jsx(Body, { children: body }), linkText && _jsx(Link, { href: linkUrl, children: linkText })] }), _jsx(StyledCloseIconContainer, { children: _jsx(IconButton, { iconName: "itaufonts_fechar", variant: IconButtonVariants.neutral, weight: IconButtonWeights.small, onClick: handleCloseAlert }) })] })) }));
};
export default Alert;
//# sourceMappingURL=Alert.js.map